<div class="active-user">
  <a *ngIf="hasAcces" test-id="profileLink" [routerLink]="['/settings/building-profile/users/edit/', user.id]">{{
    user.fullName
  }}</a>
  <span *ngIf="!hasAcces" class="active-user-bold"> {{ user.fullName }}</span>
  <span *ifMobile="false"> {{ 'general.logged_in_as' | translate }}</span>
  <span *ifMobile="false" class="active-user-bold"> {{ user.role?.translatedName | lowercase }}</span>
</div>
